module.exports = __webpack_public_path__ + "static/media/Allergies_elements.3dbb564b.png";